export default "__VITE_ASSET__09V$pNk3__"